module.exports = __webpack_public_path__ + "img/tree-06-i-leaves.168e3f38.png";